module.exports = "/fonts/vendor/@fontsource/inter/files/inter-cyrillic-300-normal.woff2?624f20089d1569b44b5f09c09e8ce39f";